// toolbar-factory.js
export class ToolbarFactory {
	static #TOOLBAR_CLASS = 'btn-toolbar';
	static #BUTTON_GROUP_CLASS = 'btn-group';
	static #WRAPPER_CLASS = 'textarea-wrapper';

	static getOrCreateToolbar(element) {
		// Nejdřív zkusíme najít existující wrapper a toolbar
		let wrapper = element.closest('.' + this.#WRAPPER_CLASS);
		let toolbar;

		if (!wrapper) {
			// Vytvoření nového wrapperu
			wrapper = document.createElement('div');
			wrapper.className = this.#WRAPPER_CLASS;

			// Vytvoření nového toolbaru
			toolbar = document.createElement('div');
			toolbar.className = this.#TOOLBAR_CLASS + ' mb-2';

			// Přesunutí element do nové struktury
			element.parentNode.insertBefore(wrapper, element);
			wrapper.appendChild(toolbar);
			wrapper.appendChild(element);
		} else {
			// Použití existujícího toolbaru
			toolbar = wrapper.querySelector('.' + this.#TOOLBAR_CLASS);
		}

		return toolbar;
	}

	static addButton(element, buttonText, callback, tooltip = '') {
		const toolbar = this.getOrCreateToolbar(element);

		let buttonGroup = toolbar.querySelector('.' + this.#BUTTON_GROUP_CLASS);
		if (!buttonGroup) {
			buttonGroup = document.createElement('div');
			buttonGroup.className = this.#BUTTON_GROUP_CLASS + ' me-2';
			toolbar.appendChild(buttonGroup);
		}

		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'btn btn-outline-secondary btn-sm';
		button.innerHTML = buttonText;
		if (tooltip) {
			button.title = tooltip;
		}
		button.addEventListener('click', callback);

		buttonGroup.appendChild(button);
		return button;
	}
}
